<template>
	<div>
		<div style="display: flex;" v-bind:class="{
			active: selected
		}">
			<div style="flex-grow: 1;">
				<template v-if="deleting">{{ $t('deleting') }}</template>
				<!-- {{ card.type }} -->
				<strong>{{ card.card_number }}</strong>
				<br />
				Exp.: {{ card.expiration_short }}
			</div>
			<div v-on:click="remove();">
				<svg xmlns="http://www.w3.org/2000/svg" width="11.895" height="11.89" viewBox="0 0 23.79 23.781">
		          <path fill="#d0d0d0" d="M2090.83,614l8.48,8.485a2,2,0,0,1-2.82,2.829l-8.49-8.486-8.49,8.486a2,2,0,0,1-2.82-2.829l8.48-8.485-8.48-8.485a2,2,0,0,1,2.82-2.829l8.49,8.486,8.49-8.486a2,2,0,0,1,2.82,2.829Z" transform="translate(-2076.12 -602.125)"/>
		        </svg>
		    </div>
			<!-- <button :disabled="deleting" v-on:click="remove();">DEL</button> -->
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		data: () => ({
			deleting: false
		}),
		props: [
			'card',
			'selected'
		],
		methods: {
			remove() {
				Vue.api.delete('/user/credit-card/' + this.card.id, {}, {
					before: () => this.deleting = true,
					always: () => this.deleting = false,
					callback: () => this.$emit('deleted')
				});
			}
		}
	}
</script>